module.exports = __webpack_public_path__ + "img/Misi Inconsistency-Judul Report Journey.58894e8c.png";